(function () {
  'use strict';

  // Recognize old community URLs so their keywords remain editable.
  var PRODUCT_TYPE_RE = /^product_type:(?:"([^"]+)"|(.+?))\s+AND\s+(.+)$/i;
  var PRODUCT_TYPE_ONLY_RE = /^product_type:(?:"([^"]+)"|(.+))$/i;
  var LEGACY_SCOPED_RE = /^title:(.+)\s+OR\s+vendor:.+\s+OR\s+tag:.+$/i;

  function stripFuzzyMarker(term) {
    term = (term || '').trim();
    if (!term) return '';
    return term
      .split(/\s+/)
      .map(function (word) {
        return word.replace(/\*+$/g, '');
      })
      .join(' ')
      .trim();
  }


  function fuzzyKeyword(term) {
    term = stripFuzzyMarker(term);
    if (!term) return term;
    if (/^(AND|OR|NOT)$/i.test(term)) return term;
    var parts = term.split(/\s+/);
    var last = parts[parts.length - 1];
    if (!last || /:/.test(last) || /[*()"]/.test(last)) return term;
    if (/^(AND|OR|NOT)$/i.test(last)) return term;
    parts[parts.length - 1] = last + '*';
    return parts.join(' ');
  }


  function unscopeSearchTerm(term) {
    term = (term || '').trim();
    if (!term) return '';

    var multi = term.match(/^\((.+)\)\s+AND\s+(.+)$/i);
    if (multi && /product_type:/i.test(multi[1])) {
      return stripFuzzyMarker(multi[2].replace(/^title:/i, '').trim());
    }

    var ptMatch = term.match(PRODUCT_TYPE_RE);
    var inner = ptMatch ? (ptMatch[3] || '').trim() : term;

    if (!ptMatch) {
      var ptOnly = term.match(PRODUCT_TYPE_ONLY_RE);
      if (ptOnly) return '';
    }

    var legacy = inner.match(LEGACY_SCOPED_RE);
    if (legacy) return stripFuzzyMarker(legacy[1]);

    if (/^title:/i.test(inner)) {
      return stripFuzzyMarker(inner.replace(/^title:/i, '').trim());
    }

    return stripFuzzyMarker(inner);
  }

  function getSearchInput(form) {
    return form.querySelector('[data-input-search], .t4s-search-results-bar__input, .t4s-search-form__input, .js_iput_search, input[name="q"]:not([data-input-q]), [name="q"]');
  }

  function getOrCreateHiddenQ(form, visibleInput) {
    var hidden = form.querySelector('input[data-input-q][name="q"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'q';
      hidden.setAttribute('data-input-q', '');
      form.appendChild(hidden);
    }
    if (visibleInput && visibleInput.getAttribute('name') === 'q') {
      visibleInput.removeAttribute('name');
      visibleInput.setAttribute('data-search-display', '1');
    }
    return hidden;
  }

  function ensureHidden(form, name, value) {
    if (!form) return null;
    var el = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
    return el;
  }

  function ensureSearchOptions(form) {
    if (!form) return;
    ensureHidden(form, 'type', 'product');
    ensureHidden(form, 'options[prefix]', 'last');
    ensureHidden(form, 'options[unavailable_products]', 'last');
  }


  function scopeSearchTerm(term) {
    return unscopeSearchTerm(term);
  }

  function applyFuzzyToQuery(term) {
    return fuzzyKeyword(unscopeSearchTerm(term));
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-t4s-search-scope-bound')) return;
    form.setAttribute('data-t4s-search-scope-bound', '1');
    var input = getSearchInput(form);
    if (!input) return;
    var hidden = getOrCreateHiddenQ(form, input);
    input.value = unscopeSearchTerm(input.value || '');
    ensureSearchOptions(form);
    form.querySelectorAll('input[name="community"]').forEach(function (field) {
      field.remove();
    });
    form.addEventListener('submit', function (event) {
      var keyword = unscopeSearchTerm(input.value || '');
      if (!keyword) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.focus();
        return;
      }
      hidden.value = applyFuzzyToQuery(keyword);
      input.value = keyword;
    });
  }

  function sanitizeVisibleInputs() {
    document.querySelectorAll('.t4s-search-results-bar__input, [data-search-display]').forEach(function (input) {
      input.value = unscopeSearchTerm(input.value || '');
    });
  }

  function init() {
    document.querySelectorAll('[data-frm-search], .t4s-search-results-bar__frm, .t4s-search-page-form, .js_frm_search_none').forEach(bindForm);
    sanitizeVisibleInputs();
  }

  window.T4SSearchScope = {
    scopeSearchTerm: scopeSearchTerm,
    unscopeSearchTerm: unscopeSearchTerm,
    applyFuzzyToQuery: applyFuzzyToQuery,
    fuzzyKeyword: fuzzyKeyword
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', sanitizeVisibleInputs);
})();
